<template>
  <CCard class="p-5">
    <div class="flex items-center justify-between mb-3">
      <CPreloader loading width="92px" height="22px" />
      <CPreloader loading width="44px" height="22px" />
    </div>
    <div v-for="el of 11" :key="el">
      <div class="relative w-full h-fit">
        <div class="absolute z-10 bg-white px-1 text-gray text-xs font-medium">
          <CPreloader loading width="58px" height="14px" />
        </div>
        <div
          class="absolute w-full -top-5 h-8 border-b border-dashed border-gray-50"
        ></div>
        <div
          class="absolute z-10 right-0 bg-white px-1 text-dark-100 text-xs font-normal"
        >
          <CPreloader loading width="100px" height="14px" />
        </div>
      </div>
      <br />
    </div>
    <CPreloader loading width="100%" height="40px" />
  </CCard>
</template>

<script setup lang="ts">
import CCard from "@/components/Card/CardWrapper.vue";
import CPreloader from "@/components/CPreloader.vue";
</script>

<style scoped></style>
